import { ViewStyleProps } from '../../../components/View/View.types';
import { ListProps } from './List.types';

export const getListStyles = (
  styledProp: ListProps['styled']
): ViewStyleProps => {
  const tokenProps: ViewStyleProps = {};

  if (!styledProp) {
    tokenProps.listStyleType = 'none';
  } else {
    tokenProps.paddingInlineStart = '1000';
  }

  return tokenProps;
};

export const getListItemStyles = (
  use: ListProps['use'],
  inline: ListProps['inline']
): ViewStyleProps => {
  const tokenProps: ViewStyleProps = {};

  if (inline || use === 'inline-divided') {
    tokenProps.display = 'inline-block';
  }
  if (use === 'inline-divided') {
    tokenProps.insetInlineStart = '200';
  }

  return tokenProps;
};
